import { ICorporatePart } from 'corporate/types';

export const CorporatePartHelper = {
  isSetUp: (corporatePart?: Partial<ICorporatePart>): boolean =>
    Boolean(corporatePart?.id) || Boolean(corporatePart?.isPnb),

  isEditable: (corporatePart?: Partial<ICorporatePart>): boolean =>
    Boolean(corporatePart?.id) || !corporatePart?.isPnb,
};
